<template>
  <span>
    <v-data-table
      class="tasks-table"
      :headers="headers"
      :items="tasks"
      :options.sync="options"
      :server-items-length="serverItemsLength"
      :loading="loading"
      fixed-header
      dense
      no-data-text="Нет данных для отображения"
      :footer-props="{
        itemsPerPageText: 'Число заданий на странице',
        itemsPerPageOptions: [25, 50]
      }"
    >
      <template v-slot:top>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Поиск по номеру счетчика"
            single-line
            hide-details
          />
        </v-card-title>
      </template>
      <tr
        slot="item"
        slot-scope="props"
      >
        <td>
          <router-link
            :to="'/counters?search=' + props.item.counter_num"
            title="Переход в раздел счетчики"
          >{{ props.item.counter_num }}</router-link>
          <a
            class="external-link"
            target="_blank"
            :href="'/counters?search=' + props.item.counter_num"
            title="Открыть раздел счетчики, в новой вкладке(окне)"
          ><v-icon>mdi-open-in-new</v-icon></a>
        </td>
        <td>
          {{ props.item.counter_model }}
        </td>
        <td>
          <router-link
            :to="'/points/' + props.item.point_id + '/scheduler'"
            title="Переход в раздел Точки учета"
          >{{ props.item.point_number }}</router-link>
          <a
            v-if="props.item.point_number"
            class="external-link"
            target="_blank"
            :href="'/points/' + props.item.point_id + '/scheduler'"
            title="Открыть раздел Точки учета, в новой вкладке(окне)"
          ><v-icon>mdi-open-in-new</v-icon></a>
        </td>
        <td>
          <span class="action-btns">
            <span v-if="props.item.state === 'working'">
              <v-btn
                icon
                class="mt-1"
                title="Остановить выполнение расписания"
                @click="stopTasks(props.item)"
              >
                <v-icon color="red darken-1">stop</v-icon>
              </v-btn>
            </span>
            <span v-else>
              <v-btn
                icon
                class="mt-1"
                title="Запустить выполенение расписания"
                @click="startTasks(props.item)"
              >
                <v-icon
                  v-if="props.item.state === 'stopped'"
                  color="green darken-1"
                >play_arrow</v-icon>
                <v-icon
                  v-else
                  color="yellow darken-1"
                >pause</v-icon>
              </v-btn>
            </span>
          </span>
        </td>
        <td>
          <span class="action-btns">
            <v-btn
              icon
              class="mt-1"
              title="Лог выполнения"
              @click="viewCounterTaskLog(props.item)"
            >
              <v-icon color="grey darken-1">fas fa-file-alt</v-icon>
            </v-btn>
          </span>
        </td>
      </tr>
    </v-data-table>
    <v-bottom-sheet v-model="showLog">
      <task-logs :task="editedTaskItem" />
    </v-bottom-sheet>
  </span>
</template>

<script>
import TaskLogs from '../shared-components/TaskLogs'
import axios from 'axios'

export default {
  name: 'Tasks',
  components: {
    TaskLogs
  },
  data () {
    return {
      showLog: false,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      headers: [
        { text: 'Номер счётчика', value: 'counter_num' },
        { text: 'Модель счетчика', value: 'counter_model' },
        { text: 'Номер Точки учёта', value: 'point_number' },
        { text: 'Состояние', value: 'state' },
        { text: 'Действия', value: 'actions' }
      ],
      editedTaskItem: { counter_id: '', counter_parameters: [] },
      startTaskDate: false,
      tasks: [],
      getTimer: '',
      deleteTimer: '',
      search: '',
      searchTimer: ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getTasksApiTimer()
      },
      deep: true
    },
    search () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.options.page = 1
        this.getTasksApiTimer()
      }, 500)
    }
  },
  mounted () {
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  methods: {
    getTasksApi () {
      this.loading = true
      axios.get(`/api/counters_tasks/?per_page=${this.options.itemsPerPage}&page=${this.options.page}&search=${this.search}&order_by=counter_id`)
        .then((response) => {
          this.tasks = response.data.results
          this.serverItemsLength = response.data.count
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTasksApiTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getTasksApi()
      }, 100)
    },
    startCounterTaskApi (item) {
      const id = item.counter_task_id
      axios.post(`/api/counters_tasks/${id}/start_scheduler/`)
        .then((response) => {
          const index = this.tasks.indexOf(item)
          Object.assign(this.tasks[index], response.data)
          this.editedTaskItem = Object.assign({}, response.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    stopCounterTaskApi (item) {
      const id = item.counter_task_id
      axios.post(`/api/counters_tasks/${id}/stop_scheduler/`)
        .then((response) => {
          const index = this.tasks.indexOf(item)
          Object.assign(this.tasks[index], response.data)
          this.editedTaskItem = Object.assign({}, response.data)
        })
        .catch((err) => {
          console.log(err)
        })
      this.taskEditing = false
    },
    stopTasks (item) {
      this.stopCounterTaskApi(item)
    },
    startTasks (item) {
      this.startCounterTaskApi(item)
    },
    viewCounterTaskLog (item) {
      this.showLog = true
      this.editedCounterTaskIndex = this.tasks.indexOf(item)
      this.editedTaskItem = Object.assign({}, item)
    }
  }
}
</script>

<style lang="scss">
  .tasks-table {
    position: absolute;
    height: 100%;
    right: 0;
    left: 0;
    .v-data-table__wrapper {
      max-height: calc(100% - 59px);
    }
  }
  .action-btns {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/spa/Tasks.vue